import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  Button,
  Space,
  Tag
} from '@lockerpm/design';

import {
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';

import itemsComponents from "../../../../components/items";
import common from "../../../../utils/common";
import global from "../../../../config/global";
import storeActions from "../../../../store/actions";

const AliasCard = (props) => {
  const { TextCopy, CloudImageIcon } = itemsComponents;
  const {
    className,
    alias,
    onEdit = () => {},
    onDelete = () => {}
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
  }, [])

  const aliasStatus = useMemo(() => {
    return common.aliasStatus(alias)
  }, [alias])

  return (
    <Card className={className} bodyStyle={{ padding: 16 }}>
      <div className="flex items-center justify-between">
        <TextCopy className="font-semibold" value={alias.full_address}/>
        <Space>
          <Button
            type="text"
            size="small"
            icon={<CloudImageIcon
              name="create-item"
              width={16}
              height={16}
            />}
            onClick={() => {
              global.store.dispatch(storeActions.updateSelectedAlias(alias.full_address));
              global.navigate(global.keys.PASSWORDS, {}, {is_create: 1})
            }}
          />
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={() => onEdit()}
          />
          <Button
            type="text"
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete()}
          />
        </Space>
      </div>
      <p>
        {t('common.created')}: {common.convertDateTime(alias.created_time, 'LL')}
      </p>
      <Space className="mt-4" size={24} wrap>
        <p>
          <b>{alias.num_forwarded}</b> <span>{t('private_email.forwarded')}</span>
        </p>
        <p>
          <b>{alias.num_blocked}</b> <span>{t('private_email.blocked')}</span>
        </p>
        <p>
          <Tag color="green">
            {t(`private_email.manage_alias.${aliasStatus}`)}
          </Tag>
        </p>
      </Space>
    </Card>
  );
}

export default AliasCard;